interface CreateTableCFG{
    keyPath: string
    indexs?: Array<any>
}

interface CFG {
    dbName: string
    version?: number
    autoTable?: boolean
    tableCfg?: CreateTableCFG
    tableName?: string
    onError?: (event: Event) => {}
    onSuccess?: (event: Event) => {}
    onUpgradeneeded?: (event: Event) => {}
    
}
class DB {
    private db: IDBDatabase
    private cfg: CFG
    constructor(cfg: CFG) {
        this.cfg = cfg
        this.db = null as unknown as IDBDatabase
        this.init()
    }

    // 打开/创建数据库
    private init() {
        if (!window.indexedDB) {
            console.log('你的浏览器不支持该版本')
            return
        }


        const request = window.indexedDB.open(this.cfg.dbName, this.cfg.version || 1)
        request.onerror = (event: Event) => {
            this.cfg.onError?.(event)
        }


        request.onsuccess = (event: Event) => {
            this.db = request.result
            this.cfg?.onSuccess?.(event)
        }

        request.onupgradeneeded = (event: any) => {
            this.db = event.target?.result
            if(this.cfg.tableName && this.cfg.tableCfg){
                this.createTable(this.cfg.tableName, this.cfg.tableCfg)
            }
        }
    }


    // 添加表
    private createTable(name: string, opts: CreateTableCFG) {
        let objectStore: any
        if (!this.db.objectStoreNames.contains(name)) {
            opts = {
                keyPath: opts.keyPath,
                indexs: Array.isArray(opts.indexs) ? opts.indexs : []
            }
            objectStore = this.db.createObjectStore(name, { keyPath: opts.keyPath })

            if (opts.indexs) {
                opts.indexs.forEach((item: any) => {
                    objectStore.createIndex(item.indexName, item.key, { unique: item.unique })
                })
            }
            return objectStore
        }
    }

    // 访问表中数据
    get(keyPathVal: any, tableName: string = this.cfg.tableName as string): Promise<{status: number, data: any}> {
        return new Promise((resolve, reject) => {
            try {
                let transaction = this.db.transaction([tableName])
                let objectStore = transaction.objectStore(tableName)
                let request = objectStore.get(keyPathVal)
    
                request.onerror = function (event: Event) {
                    resolve({ status: 500, data: event })
                }
    
                request.onsuccess =  (event: Event) => {
                    if (request.result) {
                        // 判断缓存是否过期
                        if (request.result.ex < Date.now()) {
                            resolve({ status: 200, data: null })
                            this.del(keyPathVal, tableName)
                        } else {
                            resolve({ status: 200, data: request.result })
                        }
                    } else {
                        resolve({ status: 200, data: null })
                    }
                }
            } catch (error) {
                resolve({ status: 500, data: error })
            }
        
        })
    }

    // 遍历访问表中所有数据
    getAll(tableName: string = this.cfg.tableName as string) {
        return new Promise((reslove, reject) => {
            let objectStore = this.db.transaction(tableName).objectStore(tableName)
            let result: any = []
            objectStore.openCursor().onsuccess = function (event: any) {
                let cursor = event.target.result

                if (cursor) {
                    result.push(cursor.value)
                    cursor.continue()
                } else {
                    reslove({ status: 200, data: result })
                }
            }

            objectStore.openCursor().onerror = function (event: Event) {
                reject({ status: 500, msg: '事务失败', err: event })
            }
        })
    }

    // 从表中添加一条数据
    add(row: any, ex: number = 24 * 60 * 60 * 1000, tableName: string = this.cfg.tableName as string,) {
        return new Promise((reslove, reject) => {
            let request = this.db.transaction([tableName], 'readwrite')
                .objectStore(tableName)
                .add(Object.assign(row, ex ? { ex: Date.now() + ex } : {}))
            request.onsuccess = function (event: Event) {
                reslove({ status: 200, msg: '数据写入成功' })
            }

            request.onerror = function (event: Event) {
                reject({ status: 500, msg: '数据写入失败', err: row })
            }
        })

    }

    // 更新表中的数据
    update(row: any, tableName: string = this.cfg.tableName as string) {
        return new Promise((reslove, reject) => {
            let request = this.db.transaction([tableName], 'readwrite')
                .objectStore(tableName)
                .put(row)

            request.onsuccess = function (event: Event) {
                reslove({ status: 200, msg: '数据更新成功' })
            }

            request.onerror = function (event: Event) {
                reject({ status: 500, msg: '数据更新失败', err: event })
            }
        })
    }

    // 删除某条数据
    del(keyPathVal: any, tableName: string = this.cfg.tableName as string) {
        return new Promise((resolve, reject) => {
            let request = this.db.transaction([tableName], 'readwrite')
                .objectStore(tableName)
                .delete(keyPathVal)

            request.onsuccess = function (event: Event) {
                resolve({ status: 200, msg: '数据删除成功' })
            }

            request.onerror = function (event: Event) {
                reject({ status: 500, msg: '数据删除失败', err: event })
            }
        })
    }

    // 清空表数据
    clear(tableName: string = this.cfg.tableName as string) {
        return new Promise((resolve, reject) => {
            let request = this.db.transaction([tableName], 'readwrite')
                .objectStore(tableName)
                .clear()

            request.onsuccess = function (event: Event) {
                resolve({ status: 200, msg: '数据表已清空' })
            }

            request.onerror = function (event: Event) {
                reject({ status: 500, msg: '数据表清空失败', err: event })
            }
        })
    }
}

export default DB